import handleCreateTodos from './handleCreateTodos';
import { insertTodosAtIndex } from '../actions/todoFolderViewActions';
import { Todo, createTodo } from 'owa-todo-types';
import { todosAdded } from '../actions/todoFolderViewActions';
import { now } from 'owa-datetime';

export async function createTasks(todos: Partial<Todo>[], folderId: string) {
    const fullTodos: Todo[] = todos.map((todo, index) =>
        createTodo({
            OrderDateTime: now(),
            ...todo,
        })
    );

    insertTodosAtIndex(fullTodos, 0);

    // Kick off the add todo actions and reload folder
    await handleCreateTodos(fullTodos, folderId);

    // reload the folder irrespective of success.
    todosAdded();
}
